/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CloneTemplateResponse {
    getFixupPrototypeFunction() { return CloneTemplateResponse.fixupPrototype; }

    static newInstance(model: Partial<CloneTemplateResponse>): CloneTemplateResponse {
        let obj = Object.assign(new CloneTemplateResponse(), model);
        CloneTemplateResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CloneTemplateResponse>): CloneTemplateResponse {
        if (!model) return null;
        return CloneTemplateResponse.newInstance(<CloneTemplateResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CloneTemplateResponse) {
        if (!obj) return;

        models.CloneTemplateResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CloneTemplateResponse): boolean {
        Object.setPrototypeOf(obj, CloneTemplateResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Clone template response
     */
    message: string;

    /**
     * Create Monitoring Template Details
     */
    data: any;

}
